import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { HttpError, UserCustomizationsModel } from '@rd/types';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { UserCustomizationsApiService } from '../../../services/user-customizations-api/user-customizations-api.service';
import * as actions from '../actions/user-customizations.actions';
import { UserCustomizationsState } from '../reducers/user-customizations.reducer';

@Injectable()
export class UserCustomizationsEffects {
  constructor(
    private store: Store<UserCustomizationsState>,
    private actions$: Actions,
    private userCustomizationsApiService: UserCustomizationsApiService,
  ) {}

  putUserCustomizations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.UserCustomizationsActionTypes.PUT_USER_CUSTOMIZATIONS),
      switchMap((action: actions.PutUserCustomizations) => {
        return this.userCustomizationsApiService
          .updateUserCustomizations(action.payload)
          .pipe(
            // Refetch the user customizations since NN return null on put success
            map(() => new actions.PutUserCustomizationsSuccess()),
            tap(() => this.store.dispatch(new actions.GetUserCustomizations())),
            catchError((error: HttpError) =>
              of(new actions.PutUserCustomizationsFail(error)),
            ),
          );
      }),
    ),
  );

  getUserCustomizations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.UserCustomizationsActionTypes.GET_USER_CUSTOMIZATIONS),
      switchMap((action: actions.GetUserCustomizations) => {
        return this.userCustomizationsApiService.getUserCustomizations().pipe(
          map(
            (userCustomizations: UserCustomizationsModel) =>
              new actions.GetUserCustomizationsSuccess(userCustomizations),
          ),
          catchError((error: HttpError) =>
            of(new actions.GetUserCustomizationsFail(error)),
          ),
        );
      }),
    ),
  );
}
